import { IGenerateDeviceCodeService } from './IGenerateDeviceCodeService';
import { ulid } from 'ulid';

export class GenerateUlidCode implements IGenerateDeviceCodeService {
    genDeviceCode(): string {
        return ulid();
    }
}
